module.exports = __webpack_public_path__ + "static/media/TN-Men-Knit-v2.0.07261cb2.svg";